/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
import styled from 'styled-components';
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {
  X,
} from "../../Constants/assets";
// Stylings

const InnerContainer = styled.div`
  position: absolute;
  width: min(460px, 92vw);
  min-height: 330px;
  height: auto;
  max-height: 85vh;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: start;
  position: absolute;
  font-family: "Roboto", sans-serif;
  z-index: 100;
  animation: zoomIn 0.2s ease-in-out;
  overflow-y: auto;
`;
const Wrapper = styled.div`
  padding: clamp(20px, 3vw, 40px);
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;
const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
`;
const XWrapper = styled.div`
cursor: pointer;
`;
const Paragraph = styled.div`
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 15px;
  overflow-wrap: anywhere;
`;
const InputWrapper = styled.div`
  font-size: 90%;
  display: grid;
  width: 100%;
  max-width: 300px;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-size: 13px;
  margin-left: 6px;
`;

const Input = styled.select`
  width: 100%;
  height: 3.125rem;
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 4px;
  font-size: 16px;
  padding-left: 10px;
  ::-ms-reveal {
    display: none;
  }
`;

const Button = styled.button`
border: none;
font-weight: bold;
font-size: 16px;
color: ${(props) => props.theme.colors.white};
background: ${(props) => props.theme.colors.darkGreen};
border-radius: 4px;
width: 100%;
max-width: 300px;
height: 3.125rem;
cursor: pointer;
:active {
  background: ${(props) => props.theme.colors.lightGray};
}
`;

// TODO: Fix this, this is temporary fix
const ChangeProjectPopUp = ({
  show,
  changeProject,
  allMainProjects,
  restartGameWithNewProject,
  currentProjectId,
}) => {

  const [selectedProject, setSelectedProject] = useState(0);
  const { t } = useTranslation();
  useEffect(() => {
    setSelectedProject(allMainProjects.filter(p => p.id !== currentProjectId)[0]?.id);
  }, [show]);

  if (show) {
    return (
      <InnerContainer>
        <Wrapper>
          <Header>
            <Title>
              {t('modals.change_project.info_title')}
            </Title>
            <XWrapper><X onClick={() => changeProject(false)} /></XWrapper>
          </Header>
          <Paragraph>
          {t('modals.change_project.info_text')}
          </Paragraph>
          <InputWrapper>
            <Label>{t('modals.change_project.project')}</Label>
            <Input onChange={(event) => setSelectedProject(event.target.value)}>
              {allMainProjects.map((element, index) => (
                currentProjectId !== element.id ? (
                  <option key={index} value={element.id}>
                    {t(`global_variables.projects.${element.id}.project_name`)}                   
                  </option>
                ) : null
              ))}
            </Input>
          </InputWrapper>
          <Button onClick={() => { restartGameWithNewProject(selectedProject) }}>{t('modals.change_project.button1')}</Button>
        </Wrapper>
      </InnerContainer>
    );
  }
  return null;
};
export default React.memo(ChangeProjectPopUp);
